module.exports = __webpack_public_path__ + "img/404.67c8bc5f.gif";